import { RootState } from "../reducers";
import { ClipboardState } from "../reducers/clipboardReducers";

export const CurrentClipboardSelector = (state: RootState): ClipboardState =>
  state.clipboard;
